import './EditDecisionMakerSet.scoped.scss'
import { useAct } from 'FlowBuilder/store'
import isValidEmail from 'Shared/functions/validateEmail'

export default function EditDecisionMakerSet({ actionId }) {
  const act = useAct()
  const decisionMakers = useSel(s => (s.actions.entities[actionId]?.config?.decisionMakers || []).filter(dm => dm.active))

  const [newDecisionMakerDetails, setNewDecisionMakerDetails] = useState({ email: '', name: '' })
  const [showNewDecisionMaker, setShowNewDecisionMaker] = useState(false)

  const saveNewDecisionMaker = () => {
    if (newDecisionMakerDetails.email && newDecisionMakerDetails.name && isValidEmail(newDecisionMakerDetails.email)) {
      const id = uuidv4()
      act.actions.upsertDecisionMaker(actionId, id, { ...newDecisionMakerDetails, active: true })
      setNewDecisionMakerDetails({ email: '', name: '' })
    }
    if (showNewDecisionMaker) {
      setShowNewDecisionMaker(false)
    }
  }

  const removeDecisionMaker = (id) => {
    act.actions.markDecisionMakerInactive(actionId, id)
  }

  const emailIsInDmSetAlready = (email) => {
    return !decisionMakers.some(dm => dm.email === email)
  }

  const newEmailIsBad = () => {
    return (newDecisionMakerDetails?.email && !isValidEmail(newDecisionMakerDetails?.email)) ||
      (newDecisionMakerDetails?.email && !emailIsInDmSetAlready(newDecisionMakerDetails?.email)) ||
      (newDecisionMakerDetails?.name && !newDecisionMakerDetails?.email)
  }
  const newNameIsBad = () => {
    return (newDecisionMakerDetails?.email && !newDecisionMakerDetails?.name)
  }

  const isValid = !newEmailIsBad() && !newNameIsBad() && newDecisionMakerDetails?.email && newDecisionMakerDetails?.name && isValidEmail(newDecisionMakerDetails?.email)

  const resetForm = () => {
    setNewDecisionMakerDetails({ email: '', name: '' })
    setShowNewDecisionMaker(false)
  }

  return <div>
    <div className="decision-makers">
      {decisionMakers.map((dm, idx) => (
        <div className="decision-maker-row" key={idx}>
          <input
            type="text"
            placeholder="Name"
            value={dm.name || ''}
            onChange={e => act.actions.upsertDecisionMaker(actionId, dm.id, { name: e.target.value })}
            className="input"
          />
          <input
            type="email"
            placeholder="Email"
            value={dm.email || ''}
            onChange={e => act.actions.upsertDecisionMaker(actionId, dm.id, { email: e.target.value })}
            className={
              "input" + (newDecisionMakerDetails.email == dm.email ? " error" : "")
            }
          />
          <button
            type="button"
            className="button bigger-text icon-button"
            onClick={() => removeDecisionMaker(dm.id)}
            title="Remove"
          >
            &times;
          </button>
        </div>
      ))}
      {showNewDecisionMaker &&
        <div className="margin-top">
          <label><strong>New recipient details</strong></label>
          <div className="decision-maker-row new-decision-maker margin-top">
            <input
              type="text"
              placeholder="Name"
              value={newDecisionMakerDetails.name || ''}
              onChange={e => setNewDecisionMakerDetails({ ...newDecisionMakerDetails, name: e.target.value })}
              className={
                "input" + (newNameIsBad() ? " error" : "")
              }
            />
            <input
              type="email"
              placeholder="Email"
              value={newDecisionMakerDetails.email || ''}
              onChange={e => setNewDecisionMakerDetails({ ...newDecisionMakerDetails, email: e.target.value })}
              className={
                "input" + (newEmailIsBad() ? " error" : "")
              }
            />
            <button
              type="button"
              className="button bigger-text icon-button"
              onClick={() => {
                setNewDecisionMakerDetails({ email: '', name: '' })
                setShowNewDecisionMaker(false)
              }}
              title="Remove"
            >
              &times;
            </button>
          </div>
        </div>
      }
    </div>
    { !showNewDecisionMaker && <button
      type="button"
      className="button secondary margin-top half small"
      onClick={() => setShowNewDecisionMaker(true)}
      disabled={newEmailIsBad() || newNameIsBad()}
      title="Add"
    >
      New recipient
    </button> }
    { showNewDecisionMaker && <>
      <button
        type="button"
        className="button primary margin-top margin-right half small"
        onClick={saveNewDecisionMaker}
        disabled={!isValid}
        title="Save"
      >
        Add recipient
      </button>
      <button
        type="button"
        className="button secondary margin-top half small"
        onClick={resetForm}
        title="Cancel"
      >
        Cancel
      </button>
    </> }
  </div>
}
